import { Component, OnDestroy, OnInit } from '@angular/core';
import { LaunchDarklyService } from 'src/app/shared/services/launch-darkly.service';

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit, OnDestroy {
  headerText: any;
  rebranding: any;

  constructor(private _launchDarklyService: LaunchDarklyService) {}

  ngOnInit(): void {
    this.loadBranding().then((branding)=>{
      this.headerText = branding.headerTittle;
      this.rebranding = branding.rebranding;
    });
  }
  ngOnDestroy(): void {
    this._launchDarklyService.client.close();
  }

  async loadBranding(): Promise<any> {
    await this._launchDarklyService.client.waitUntilReady();
    const rebrandingEnabled = this._launchDarklyService.client.variation('tp-rebranding', false);
    const branding = { rebranding: false, pageTittle: 'Transfer Pricing', headerTittle: 'Transfer Pricing' };
    if (rebrandingEnabled) {
      branding.pageTittle = 'Exactera';
      branding.headerTittle = 'Exactera Transfer Pricing';
      branding.rebranding = true;
    }
    return branding;
  }
}
